import { useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const MAX_DURATION = 0.5;
const MAX_STAGGER = 0.06;

export function useJoinMotion() {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return {
      reduceMotion: true,
      fadeUp: {},
      stagger: {},
      item: {},
      hero: {},
      heroMotif: {},
      editorialRow: {},
      cardFocus: {},
    };
  }

  return {
    reduceMotion: false,
    fadeUp: {
      initial: { opacity: 0, y: 20 },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true, amount: 0.2 },
      transition: { duration: MAX_DURATION, ease: EASE },
    },
    stagger: {
      initial: "hidden",
      whileInView: "visible",
      viewport: { once: true, amount: 0.12 },
      variants: {
        hidden: {},
        visible: { transition: { staggerChildren: MAX_STAGGER } },
      },
    },
    item: {
      variants: {
        hidden: { opacity: 0, y: 14 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.4, ease: EASE },
        },
      },
    },
    hero: {
      initial: { opacity: 0, y: 16 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: MAX_DURATION, ease: EASE },
    },
    heroMotif: {
      initial: { opacity: 0, scale: 0.96 },
      animate: { opacity: 1, scale: 1 },
      transition: { duration: 0.55, ease: EASE, delay: 0.08 },
    },
    editorialRow: {
      initial: { opacity: 0, x: -12 },
      whileInView: { opacity: 1, x: 0 },
      viewport: { once: true, amount: 0.15 },
      transition: { duration: 0.45, ease: EASE },
    },
    cardFocus: {
      variants: {
        hidden: { opacity: 0, y: 10 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.35, ease: EASE },
        },
      },
    },
  };
}
